import React from "react";
import { useNavigate } from "react-router-dom";
function TermsCondition() {
  const navigate = useNavigate();
  const handleLinkPage = () => {
    navigate(`/register`);
  };
  return (
    <div className="bg-background-app grid grid-cols-12 w-screen h-auto font-noto-sans-thai">
      <div className="col-span-10 md:col-span-8 col-start-2 md:col-start-3 w-full h-auto my-10 md:my-20 ">
        <div className="bg-primary-contrast rounded-[40px] h-[calc(100vh_-_11rem)] shadow-z16 p-4 lg:p-8 flex flex-col gap-12">
          <div className="flex flex-col gap-1">
            <button
              className="bg-primary-main w-6 h-6 self-end rounded-full"
              onClick={handleLinkPage}
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M16.7782 7.22943C16.4824 6.93364 16.0045 6.93364 15.7088 7.22943L12 10.9306L8.29124 7.22184C7.99545 6.92605 7.51763 6.92605 7.22184 7.22184C6.92605 7.51763 6.92605 7.99545 7.22184 8.29124L10.9306 12L7.22184 15.7088C6.92605 16.0045 6.92605 16.4824 7.22184 16.7782C7.51763 17.0739 7.99545 17.0739 8.29124 16.7782L12 13.0694L15.7088 16.7782C16.0045 17.0739 16.4824 17.0739 16.7782 16.7782C17.0739 16.4824 17.0739 16.0045 16.7782 15.7088L13.0694 12L16.7782 8.29124C17.0664 8.00303 17.0664 7.51763 16.7782 7.22943Z"
                  fill="white"
                />
              </svg>
            </button>
            <p className="self-center text-xl font-bold text-text-primary">
              ข้อตกลงการใช้งาน
            </p>
          </div>
          <div className="flex flex-col gap-4 overflow-y-auto">
            <div className="flex flex-col gap-4">
              <p className="text-text-primary text-base font-semibold">
                ร่างนโยบายคุกกี้
              </p>
              <p className="text-text-primary font-medium text-base indent-8">
                สำนักงานพัฒนาเทคโนโลยีอวกาศและภูมิสารสนเทศ (องค์การมหาชน)
                มีการใช้คุกกี้ เพื่อบันทึกกิจกรรมการเข้าเยี่ยมชม
                หรือใช้บริการเว็บไซต์ของเจ้าของข้อมูลส่วนบุคคล
                เพื่อให้เว็บไซต์สามารถให้บริการเจ้าของข้อมูลส่วนบุคคลได้มีประสิทธิภาพมากยิ่งขึ้นโดยข้อมูลคุกกี้จะถูกนำไปใช้เพื่อวัตถุประสงค์สำหรับปรับปรุงเว็บไซต์ของสำนักงานพัฒนาเทคโนโลยีอวกาศและภูมิสารสนเทศ
                (องค์การมหาชน) ให้ตรงกับการทำงานมากยิ่งขึ้น
                และเพื่ออำนวยความสะดวกให้แก่เจ้าของข้อมูลส่วนบุคคลในการใช้งานเว็บไซต์ ของสำนักงานพัฒนาเทคโนโลยีอวกาศและภูมิสารสนเทศ
                (องค์การมหาชน) ในอนาคต
              </p>
              <p className="text-text-primary font-medium text-base indent-8">
                คุกกี้ที่สำนักงานพัฒนาเทคโนโลยีอวกาศและภูมิสารสนเทศ
                (องค์การมหาชน) ใช้มีรายละเอียดดังนี้
              </p>
              <p className="text-text-primary font-medium text-base indent-8">
                1. คุกกี้ที่มีความจำเป็น (Strictly Necessary Cookies)
                คุกกี้ประเภทนี้มีความจำเป็นต่อการให้บริการเว็บไซต์ของสำนักงานพัฒนาเทคโนโลยีอวกาศและภูมิสารสนเทศ
                (องค์การมหาชน)
                เพื่อให้เจ้าของข้อมูลส่วนบุคคลสามารถเข้าใช้งานในส่วนต่าง ๆ
                ของเว็บไซต์ได้ รวมถึงช่วยจดจำข้อมูลที่ท่านเคยให้ไว้ ผ่านเว็บไซต์
              </p>
              <p className="text-text-primary font-medium text-base indent-8">
                2. คุกกี้เพื่อการวิเคราะห์และประเมินผลการใช้งาน (Performance
                Cookies) คุกกี้ประเภทนี้ช่วยให้
                สำนักงานพัฒนาเทคโนโลยีอวกาศและภูมิสารสนเทศ (องค์การมหาชน)
                ทราบถึงการปฏิสัมพันธ์ ของผู้ใช้งานในการใช้บริการเว็บไซต์ของสำนักงานพัฒนาเทคโนโลยีอวกาศและภูมิสารสนเทศ (องค์การมหาชน)
                รวมถึงหน้าเพจหรือพื้นที่ใดของเว็บไซต์ที่ได้รับความนิยม
                ตลอดจนการวิเคราะห์ข้อมูล ด้านอื่น ๆ
                สำนักงานพัฒนาเทคโนโลยีอวกาศและภูมิสารสนเทศ (องค์การมหาชน)
                ยังใช้ข้อมูลนี้เพื่อการปรับปรุงการทำงานของเว็บไซต์
                และเพื่อเข้าใจพฤติกรรมของผู้ใช้งานมากขึ้น
                โดยข้อมูลที่คุกกี้เก็บรวบรวม จะเป็นข้อมูลที่ไม่สามารถระบุตัวตนได้
                และนำมาใช้วิเคราะห์ทางสถิติเท่านั้น
              </p>
              <p className="text-text-primary font-medium text-base indent-8">
                3. คุกกี้เพื่อการใช้งานเว็บไซต์ (Functional Cookies)
                คุกกี้ประเภทนี้จะช่วยให้เว็บไซต์ ของสำนักงานพัฒนาเทคโนโลยีอวกาศและภูมิสารสนเทศ
                (องค์การมหาชน) จดจำตัวเลือกต่าง ๆ
                ที่ได้ตั้งค่าไว้และช่วยให้เว็บไซต์ส่งมอบคุณสมบัติและเนื้อหาเพิ่มเติมให้ตรงกับการใช้งานของเจ้าของข้อมูลส่วนบุคคลได้
                เช่น ช่วยจดจำชื่อบัญชีผู้ใช้งาน
                หรือจดจำการเปลี่ยนแปลงการตั้งค่าต่าง ๆ
                ของหน้าเว็บไซต์ซึ่งเจ้าของข้อมูลส่วนบุคคลสามารถปรับแต่งได้
              </p>
              <p className="text-text-primary font-medium text-base indent-8">
                ทั้งนี้เจ้าของข้อมูลส่วนบุคคลสามารถเลือกที่จะปิดการทำงานหรือลบข้อมูลคุกกี้บนอุปกรณ์ ของเจ้าของข้อมูลส่วนบุคคลได้เอง
                แต่อาจส่งผลกระทบกับการทำงานบางส่วนของเว็บไซต์ของของสำนักงานพัฒนาเทคโนโลยีอวกาศและภูมิสารสนเทศ
                (องค์การมหาชน)
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TermsCondition;
